/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSageIntacctTasksInput = {|
  sageIntacctProjectId?: ?string,
  sageIntacctItemId?: ?string,
  forecastProjectId?: ?string,
  taskIds?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CreateSageIntacctTasksMutationVariables = {|
  input: CreateSageIntacctTasksInput
|};
export type CreateSageIntacctTasksMutationResponse = {|
  +createSageIntacctTasks: ?{|
    +tasks: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +sageIntacctId: ?string,
      |}
    |}>
  |}
|};
export type CreateSageIntacctTasksMutation = {|
  variables: CreateSageIntacctTasksMutationVariables,
  response: CreateSageIntacctTasksMutationResponse,
|};
*/


/*
mutation CreateSageIntacctTasksMutation(
  $input: CreateSageIntacctTasksInput!
) {
  createSageIntacctTasks(input: $input) {
    tasks {
      node {
        id
        name
        sageIntacctId
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSageIntacctTasksInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSageIntacctTasksPayload",
    "kind": "LinkedField",
    "name": "createSageIntacctTasks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTypeEdge",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageIntacctTasksMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageIntacctTasksMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSageIntacctTasksMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageIntacctTasksMutation(\n  $input: CreateSageIntacctTasksInput!\n) {\n  createSageIntacctTasks(input: $input) {\n    tasks {\n      node {\n        id\n        name\n        sageIntacctId\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '959f66845403914ff9ba2fd1885923d0';

module.exports = node;
